import DownloadIcon from './DownloadIcon'

export default DownloadIcon
